import { render, staticRenderFns } from "./announ.vue?vue&type=template&id=7b985a1c&"
import script from "./announ.vue?vue&type=script&lang=js&"
export * from "./announ.vue?vue&type=script&lang=js&"
import style0 from "./announ.vue?vue&type=style&index=0&id=7b985a1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports